/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_B_DInputs */

const en_wc_start_b_d = /** @type {(inputs: Wc_Start_B_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Blank document from the File menu, or open a copy of an existing file. Type a paragraph, apply a heading style and try inserting a table.`)
};

/**
* | output |
* | --- |
* | "Choose Blank document from the File menu, or open a copy of an existing file. Type a paragraph, apply a heading style and try inserting a table." |
*
* @param {Wc_Start_B_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_b_d = /** @type {((inputs?: Wc_Start_B_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_B_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_b_d(inputs)
});
export { wc_start_b_d as "wc.start.b_d" }